import styled from '@emotion/styled';
import React, { useState, useEffect, Fragment } from 'react';
import { RiUserFill, RiCloseFill } from 'react-icons/ri';
import _ from 'lodash-es';
import Cookies from 'js-cookie';
import { HiOutlineUser, HiOutlineLogout } from 'react-icons/hi';
import { MdOutlineBookmarks } from 'react-icons/md';
import { FcGoogle } from 'react-icons/fc';
import { FaFacebook } from 'react-icons/fa';
import { BsLine } from 'react-icons/bs';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2;
var MENU_LIST = [{
  id: 'profile',
  nameTH: 'ข้อมูลส่วนตัว',
  nameEN: 'Profile',
  link: '/member/profile',
  icon: /*#__PURE__*/React.createElement(HiOutlineUser, {
    size: 16
  })
}, {
  id: 'following',
  nameTH: 'แท็กที่คุณสนใจ',
  nameEN: 'Following',
  link: '/member/following',
  icon: /*#__PURE__*/React.createElement(MdOutlineBookmarks, {
    size: 16
  })
}, {
  id: 'signout',
  nameTH: 'ออกจากระบบ',
  nameEN: 'Sign out',
  link: '/',
  icon: /*#__PURE__*/React.createElement(HiOutlineLogout, {
    size: 16
  })
}];
var TEXT_LIST = [{
  nameTH: 'เข้าสู่ระบบ',
  nameEN: 'Login'
}, {
  nameTH: 'เชื่อมต่อกับ',
  nameEN: 'Login with'
}, {
  nameTH: 'รายละเอียดเพิ่มเติม',
  nameEN: 'more details'
}];
var PROVIDERS_MEMBER = function PROVIDERS_MEMBER(NEXTAUTH_URL) {
  return [{
    id: 'google',
    name: 'Google',
    type: 'oauth',
    icon: React.createElement(FcGoogle, {
      id: 'google',
      size: 20
    }),
    signinUrl: NEXTAUTH_URL + "/api/auth/signin/google",
    callbackUrl: NEXTAUTH_URL + "/api/member/login"
  }, {
    id: 'facebook',
    name: 'Facebook',
    type: 'oauth',
    icon: React.createElement(FaFacebook, {
      id: 'facebook',
      size: 20
    }),
    signinUrl: NEXTAUTH_URL + "/api/auth/signin/facebook",
    callbackUrl: NEXTAUTH_URL + "/api/auth/callback/facebook"
  }, {
    id: 'line',
    name: 'Line',
    type: 'oauth',
    icon: React.createElement(BsLine, {
      id: 'line',
      size: 20
    }),
    signinUrl: NEXTAUTH_URL + "/api/auth/signin/line",
    callbackUrl: NEXTAUTH_URL + "/api/auth/callback/line"
  }];
};
var WidgetLogin = function WidgetLogin(_ref) {
  var _sessionSevId$user, _sessionSevId$user2, _sessionSevId$user3, _session$user3, _session$user4;
  var children = _ref.children,
    nextAuthUrl = _ref.nextAuthUrl,
    sendDataLayerGlobal = _ref.sendDataLayerGlobal,
    DATALAYER_TYPE = _ref.DATALAYER_TYPE,
    conditionDisabled = _ref.conditionDisabled,
    error = _ref.error,
    sessionSevId = _ref.sessionSevId,
    signOut = _ref.signOut,
    website = _ref.website,
    session = _ref.session,
    open = _ref.open,
    setOpen = _ref.setOpen,
    setError = _ref.setError,
    router = _ref.router,
    _key = _ref._key,
    signIn = _ref.signIn,
    decryptionUserSession = _ref.decryptionUserSession,
    _ref$isEn = _ref.isEn,
    isEn = _ref$isEn === void 0 ? false : _ref$isEn;
  var _useState = useState([]),
    socialArray = _useState[0],
    setSocialArray = _useState[1];
  var _useState2 = useState(null),
    cookie = _useState2[0],
    setCookie = _useState2[1];
  var _useState3 = useState(true),
    localNotExisted = _useState3[0],
    setLocalNotExist = _useState3[1];
  useEffect(function () {
    setSocialArray(typeof window !== 'undefined' ? [].concat(_.remove(PROVIDERS_MEMBER(nextAuthUrl), function (item) {
      return item.id === localStorage.getItem('login_channel');
    }), _.remove(PROVIDERS_MEMBER(nextAuthUrl), function (item) {
      return item.id !== localStorage.getItem('login_channel');
    })) : []);
    setCookie(Cookies.get('login'));
    setLocalNotExist(typeof window !== 'undefined' && Cookies.get('login') && (_.isEmpty(localStorage.getItem('login_channel')) || localStorage.getItem('login_channel') === 'undefined'));
  }, []);
  useEffect(function () {
    if (!_.isEmpty(session)) {
      var _session$user;
      var _session = !_.isEmpty(session) && decryptionUserSession(session, true, 'user');
      if (localNotExisted || localStorage.getItem('login_channel') !== (_session == null || (_session$user = _session.user) == null ? void 0 : _session$user.registeredChannel)) {
        var _session$user2;
        localStorage.setItem('login_channel', _session == null || (_session$user2 = _session.user) == null ? void 0 : _session$user2.registeredChannel);
      }
    }
  }, [session]);
  return React.createElement(WidgetWrapper, {
    id: 'widget-login'
  }, !_.isEmpty(sessionSevId) ? React.createElement(React.Fragment, null, React.createElement("div", {
    className: "btn-login login"
  }, !_.isEmpty(sessionSevId == null || (_sessionSevId$user = sessionSevId.user) == null ? void 0 : _sessionSevId$user.image) && typeof (sessionSevId == null || (_sessionSevId$user2 = sessionSevId.user) == null ? void 0 : _sessionSevId$user2.image) === 'string' ? React.createElement("img", {
    className: 'image-user',
    src: sessionSevId == null || (_sessionSevId$user3 = sessionSevId.user) == null ? void 0 : _sessionSevId$user3.image,
    width: 32,
    height: 32,
    title: 'profile',
    alt: 'profile'
  }) : React.createElement(RiUserFill, {
    size: 16
  })), React.createElement("ul", {
    className: 'menu-list'
  }, MENU_LIST.map(function (item, index) {
    return React.createElement(React.Fragment, null, item.id === 'signout' ? React.createElement("li", {
      key: index,
      className: 'list-item',
      // href={item?.link}
      // title={item.nameTH}
      onClick: function onClick() {
        return signOut({
          callbackUrl: website
        });
      }
    }, item == null ? void 0 : item.icon, React.createElement("p", null, !isEn ? item == null ? void 0 : item.nameTH : item == null ? void 0 : item.nameEN)) : React.createElement("li", {
      key: index,
      className: 'list-item'
    }, React.createElement("a", {
      href: item == null ? void 0 : item.link,
      title: item.nameTH
    }, item == null ? void 0 : item.icon, React.createElement("p", null, !isEn ? item == null ? void 0 : item.nameTH : item == null ? void 0 : item.nameEN))));
  }))) : !_.isEmpty(session) ? React.createElement(React.Fragment, null, React.createElement("div", {
    className: "btn-login login"
  }, !_.isEmpty(session == null || (_session$user3 = session.user) == null ? void 0 : _session$user3.image) ? React.createElement("img", {
    className: 'image-user',
    src: "" + (session == null || (_session$user4 = session.user) == null ? void 0 : _session$user4.image),
    width: 30,
    height: 30,
    title: 'profile',
    alt: 'profile'
  }) : React.createElement(RiUserFill, {
    size: 20
  })), React.createElement("ul", {
    className: 'menu-list'
  }, MENU_LIST.map(function (item, index) {
    return React.createElement(React.Fragment, null, item.id === 'signout' ? React.createElement("li", {
      key: index,
      className: 'list-item',
      // href={item?.link}
      // title={item.nameTH}
      onClick: function onClick() {
        return signOut({
          callbackUrl: website
        });
      }
    }, item == null ? void 0 : item.icon, React.createElement("p", null, !isEn ? item == null ? void 0 : item.nameTH : item == null ? void 0 : item.nameEN)) : React.createElement("li", {
      key: index,
      className: 'list-item'
    }, React.createElement("a", {
      href: item == null ? void 0 : item.link,
      title: item.nameTH
    }, item == null ? void 0 : item.icon, React.createElement("p", null, !isEn ? item == null ? void 0 : item.nameTH : item == null ? void 0 : item.nameEN))));
  }))) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "btn-login",
    onClick: function onClick() {
      return setOpen(true);
    }
  }, React.createElement(RiUserFill, {
    size: 20
  })), open && React.createElement(WidgetSocial, {
    id: 'widget-social'
  }, React.createElement("div", {
    className: 'modal-social'
  }, React.createElement("button", {
    className: 'btn-close',
    onClick: function onClick() {
      if (open) {
        setError('');
        setOpen(false);
        sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_POSITION,
          router: router == null ? void 0 : router.pathname,
          position: 'on:header',
          section: 'login',
          data: {
            title: _key,
            heading: 'close-login'
          }
        });
      }
    }
  }, React.createElement(RiCloseFill, {
    size: 25
  })), React.createElement("div", {
    className: 'heading'
  }, !isEn ? TEXT_LIST[0].nameTH : TEXT_LIST[0].nameEN), socialArray.map(function (item, index) {
    return React.createElement(React.Fragment, null, React.createElement("button", {
      key: index,
      className: "btn-social " + (item.id ? "icon-" + item.id + " " + (conditionDisabled ? 'disabled' : '') : ''),
      onClick: function onClick() {
        if (conditionDisabled) {
          setError('* กรุณายอมรับนโยบาย');
        } else {
          var expiryDate = new Date();
          expiryDate.setMonth(expiryDate.getMonth() + 1);
          Cookies.set('login', 'success', {
            expires: expiryDate
          });
          signIn(item == null ? void 0 : item.id);
          sendDataLayerGlobal({
            type: DATALAYER_TYPE.TRACK_INDEX,
            router: router == null ? void 0 : router.pathname,
            section: 'login',
            data: {
              heading: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A " + (item == null ? void 0 : item.id),
              title: _key,
              index: index + 1
            }
          });
        }
      }
    }, item == null ? void 0 : item.icon, React.createElement("p", null, !isEn ? TEXT_LIST[1].nameTH : TEXT_LIST[1].nameEN, " ", React.createElement("span", null, " ", item == null ? void 0 : item.id))), index === 0 && !localNotExisted && cookie ? React.createElement("div", {
      className: 'bottom-line'
    }) : null);
  }), !_.isEmpty(error) && React.createElement("label", {
    className: 'error-label'
  }, " ", !conditionDisabled ? '' : error), !cookie && React.createElement(React.Fragment, null, children, React.createElement("a", {
    className: 'link-policy',
    href: '/privacy-policy',
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: function onClick() {
      return sendDataLayerGlobal({
        type: DATALAYER_TYPE.TRACK,
        router: router == null ? void 0 : router.pathname,
        section: 'login',
        data: {
          title: _key,
          heading: 'รายละเอียดเพิ่มเติม'
        }
      });
    }
  }, !isEn ? TEXT_LIST[2].nameTH : TEXT_LIST[2].nameEN))))));
};
var WidgetWrapper = /*#__PURE__*/styled.div(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n  display: block;\n  padding: 8px 0 8px 16px;\n  @media (max-width: 768px) {\n    padding: 8px 10px 8px 16px;\n  }\n  &:hover {\n    .menu-list {\n      display: flex;\n    }\n    .btn-login {\n      svg {\n        color: #ffffffba;\n      }\n    }\n  }\n  /* ------------------------------ BUTTON LOGIN ------------------------------ */\n  .btn-login {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: transparent;\n\n    padding: 0;\n    border: none;\n    border-radius: 50px;\n    &.login {\n      border: 2px solid var(--text-color);\n      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.08)) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));\n    }\n\n    svg {\n      color: var(--text-color);\n      @media (max-width: 690px) {\n        height: 24px;\n        width: 24px;\n      }\n    }\n    .image-user {\n      overflow: hidden;\n      margin: 0px;\n      padding: 0px;\n      border-radius: 50px;\n      object-fit: cover;\n      width: 28px;\n      height: 28px;\n    }\n  }\n\n  .info {\n    font-size: 12px;\n    font-weight: 300;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-direction: column;\n    .username,\n    .email {\n      width: 150px;\n      font-size: 14px;\n      font-weight: 400;\n      text-transform: capitalize;\n\n      padding: 5px;\n      margin: 0;\n    }\n  }\n\n  .menu-list {\n    z-index: 24;\n    display: none;\n    position: absolute;\n    top: 45px;\n    right: 0;\n    background-color: #ffffff;\n    box-shadow: 1px 0px 10px 0px var(--shadow-color);\n    width: max-content;\n    flex-direction: column;\n    border-radius: 5px;\n    margin: 0;\n    padding: 10px !important;\n    &:before {\n      content: '';\n      position: absolute;\n      top: -8px;\n      right: 0px;\n      width: 0;\n      height: 0;\n      border-left: 15px solid transparent;\n      border-right: 15px solid transparent;\n      border-bottom: 15px solid white;\n    }\n    @media (max-width: 767px) {\n      left: auto;\n      right: 10px;\n      top: 47px;\n      &:before {\n        top: -5px;\n        right: 10px;\n        left: auto;\n      }\n    }\n    .list-item {\n      width: 100%;\n      margin: 0;\n      a {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        svg {\n          margin-right: 5px;\n        }\n      }\n    }\n\n    svg {\n      color: var(--primary-color);\n      font-weight: 700;\n      margin-left: 5px;\n      margin-bottom: 2px;\n      transition: all 3ms ease-in;\n    }\n    li {\n      cursor: pointer;\n      width: 100%;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      font-size: 14px;\n      font-weight: 500;\n      margin: 0;\n      padding: 8px;\n      font-family: 'Prompt', sans-serif;\n      gap: 5px;\n      z-index: 2;\n      border-radius: 5px;\n      p {\n        padding: 0;\n        margin: 0;\n        color: var(--primary-color);\n      }\n      &:hover {\n        box-shadow: 1px 0px 10px 0px rgba(237, 26, 59, 0.3);\n        background-color: var(--primary-color);\n        p,\n        svg {\n          color: #fff;\n        }\n      }\n    }\n  }\n"])));
var WidgetSocial = /*#__PURE__*/styled.div(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  background-color: rgb(0, 0, 0, 0.5);\n  z-index: 15;\n  .bottom-line {\n    width: 100%;\n    height: 2px;\n    background-color: rgba(0, 0, 0, 0.15);\n  }\n  .modal-social {\n    background: linear-gradient(103.43deg, #f6f6f6 0%, #eeeeee 100%);\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.85);\n    border-radius: 10px;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 10px;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    gap: 16px;\n    padding: 40px 30px;\n    @media (max-width: 767px) {\n      padding: 20px;\n      width: 320px;\n    }\n    @media (max-width: 380px) {\n      width: 300px;\n    }\n\n    .heading {\n      color: var(--primary-color);\n      font-size: 26px;\n      font-weight: 900;\n      display: block;\n      text-align: center;\n      margin-bottom: 10px;\n      /* border-bottom: 1px solid var(--primary-color); */\n      /* padding-bottom: 15px; */\n      @media (max-width: 767px) {\n        font-size: 24px;\n      }\n      @media (max-width: 380px) {\n        margin-top: 10px;\n        margin-bottom: 5px;\n      }\n    }\n    /* ------------------------------ BUTTON CLOSE ----------------------------- */\n    .btn-close {\n      position: absolute;\n      top: 20px;\n      right: 10px;\n      cursor: pointer;\n      border: none;\n      background-color: transparent;\n      transition: all ease 0.25ms;\n\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      svg {\n        color: var(--primary-color);\n      }\n      @media (max-width: 767px) {\n        top: 10px;\n      }\n\n      &:hover {\n        color: #474747;\n      }\n    }\n    /* ------------------------------ BUTTON SOCIAL ----------------------------- */\n    .btn-social {\n      cursor: pointer;\n      transition: background-color ease-in-out 100ms;\n      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.08)) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));\n      background-color: #ffffff;\n      border-radius: 50px;\n      color: #fff;\n      border: 0;\n\n      gap: 16px;\n      padding: 16px 30px;\n\n      width: 100%;\n      max-width: 345px;\n      margin: auto;\n      height: 48px;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      @media (max-width: 767px) {\n        padding: 16px;\n      }\n      p {\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 1.25;\n        color: #111;\n\n        span {\n          text-transform: capitalize;\n        }\n        @media (max-width: 767px) {\n          font-size: 16px;\n        }\n      }\n\n      &.icon-google {\n        color: #000000;\n        background: #ffffff;\n        &:hover {\n          background: #e5e5e5;\n          color: #ffffff;\n        }\n      }\n      &.icon-facebook {\n        background: #ffffff;\n        svg {\n          color: #337fff;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n      &.icon-line {\n        background: #ffffff;\n        svg {\n          color: #3ace01;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n      &.icon-tiktok {\n        background: #ffffff;\n        svg {\n          color: #000;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n      &.icon-linkin {\n        background: #ffffff;\n        svg {\n          color: #337fff;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n    }\n  }\n"])));

var _templateObject$1, _templateObject2$1, _templateObject3;
var MENU_LIST$1 = [{
  id: 'profile',
  nameTH: 'ข้อมูลส่วนตัว',
  nameEN: 'Profile',
  link: '/member/profile',
  icon: /*#__PURE__*/React.createElement(HiOutlineUser, {
    size: 16
  })
}, {
  id: 'following',
  nameTH: 'แท็กที่คุณสนใจ',
  nameEN: 'Following',
  link: '/member/following',
  icon: /*#__PURE__*/React.createElement(MdOutlineBookmarks, {
    size: 16
  })
}, {
  id: 'signout',
  nameTH: 'ออกจากระบบ',
  nameEN: 'Sign out',
  link: '/',
  icon: /*#__PURE__*/React.createElement(HiOutlineLogout, {
    size: 16
  })
}];
var PROVIDERS_MEMBER_AUTHO = function PROVIDERS_MEMBER_AUTHO(NEXTAUTH_URL) {
  return [{
    provider: 'google-oauth2',
    id: 'google',
    name: 'Google',
    type: 'oauth',
    icon: React.createElement(FcGoogle, {
      id: 'google',
      size: 20
    }),
    signinUrl: NEXTAUTH_URL + "/api/auth/signin/google",
    callbackUrl: NEXTAUTH_URL + "/api/auth/callback/google"
  }, {
    provider: 'facebook',
    id: 'facebook',
    name: 'Facebook',
    type: 'oauth',
    icon: React.createElement(FaFacebook, {
      id: 'facebook',
      size: 20
    }),
    signinUrl: NEXTAUTH_URL + "/api/auth/signin/facebook",
    callbackUrl: NEXTAUTH_URL + "/api/auth/callback/facebook"
  }, {
    provider: 'line',
    id: 'line',
    name: 'Line',
    type: 'oauth',
    icon: React.createElement(BsLine, {
      id: 'line',
      size: 20
    }),
    signinUrl: NEXTAUTH_URL + "/api/auth/signin/line",
    callbackUrl: NEXTAUTH_URL + "/api/auth/callback/line"
  }];
};
var TEXT_LIST$1 = [{
  nameTH: 'เข้าสู่ระบบ',
  nameEN: 'Login'
}, {
  nameTH: 'เชื่อมต่อกับ',
  nameEN: 'Login with'
}, {
  nameTH: 'รายละเอียดเพิ่มเติม',
  nameEN: 'more details'
}];
var WidgetLoginAuthO = function WidgetLoginAuthO(_ref) {
  var children = _ref.children,
    nextAuthUrl = _ref.nextAuthUrl,
    router = _ref.router,
    sendDataLayerGlobal = _ref.sendDataLayerGlobal,
    DATALAYER_TYPE = _ref.DATALAYER_TYPE,
    conditionDisabled = _ref.conditionDisabled,
    error = _ref.error,
    sessionSevId = _ref.sessionSevId,
    open = _ref.open,
    setOpen = _ref.setOpen,
    setError = _ref.setError,
    _key = _ref._key,
    _ref$isEn = _ref.isEn,
    isEn = _ref$isEn === void 0 ? false : _ref$isEn,
    _ref$isRemoveCookie = _ref.isRemoveCookie,
    isRemoveCookie = _ref$isRemoveCookie === void 0 ? true : _ref$isRemoveCookie;
  if (_.isEmpty(PROVIDERS_MEMBER_AUTHO(nextAuthUrl))) return null;
  var _useState = useState(null),
    cookie = _useState[0],
    setCookie = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  useEffect(function () {
    setCookie(Cookies.get('login'));
  }, []);
  // handleCommemorate
  function handleLogin(provider) {
    // Update the window location to the desired path
    window.location.href = "/api/auth/login?provider=" + provider;
  }
  function handleLogout() {
    // Update the window location to the desired path
    isRemoveCookie && Cookies.remove('login-data');
    Cookies.remove('login-state');
    window.location.href = "/api/auth/logout";
    isRemoveCookie && localStorage.removeItem('login-meta-data');
  }
  return React.createElement(WidgetWrapper$1, {
    id: 'widget-login'
  }, !_.isEmpty(sessionSevId) ? React.createElement(React.Fragment, null, React.createElement("button", {
    className: 'btn-login login',
    onClick: function onClick() {
      return sendDataLayerGlobal({
        type: DATALAYER_TYPE.TRACK_POSITION,
        router: router == null ? void 0 : router.pathname,
        position: 'on:header',
        section: 'login',
        data: {
          title: _key,
          heading: 'open-login'
        }
      });
    }
  }, !_.isEmpty(sessionSevId == null ? void 0 : sessionSevId.picture) && typeof (sessionSevId == null ? void 0 : sessionSevId.picture) === 'string' ? React.createElement("img", {
    className: 'image-user',
    src: sessionSevId == null ? void 0 : sessionSevId.picture,
    width: 32,
    height: 32,
    title: 'profile',
    alt: 'profile'
  }) : React.createElement(RiUserFill, {
    size: 16
  })), React.createElement("ul", {
    className: 'menu-list'
  }, MENU_LIST$1.map(function (item, index) {
    return React.createElement(Fragment, {
      key: index
    }, item.id === 'signout' ? React.createElement("li", {
      className: 'list-item',
      // href={item?.link}
      // title={item.nameTH}
      onClick: function onClick() {
        sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_POSITION,
          router: router == null ? void 0 : router.pathname,
          position: 'on:header',
          section: 'login',
          data: {
            title: (sessionSevId == null ? void 0 : sessionSevId.email) || _key,
            heading: item == null ? void 0 : item.nameTH,
            index: index + 1
          }
        });
        handleLogout();
      }
    }, item == null ? void 0 : item.icon, React.createElement("p", null, isEn ? item == null ? void 0 : item.nameEN : item == null ? void 0 : item.nameTH)) : React.createElement("li", {
      className: 'list-item'
    }, React.createElement("a", {
      href: item == null ? void 0 : item.link,
      title: item.nameTH,
      onClick: function onClick() {
        sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_POSITION,
          router: router == null ? void 0 : router.pathname,
          position: 'on:header',
          section: 'login',
          data: {
            title: (sessionSevId == null ? void 0 : sessionSevId.email) || _key,
            heading: item == null ? void 0 : item.nameTH,
            index: index + 1
          }
        });
      }
    }, item == null ? void 0 : item.icon, React.createElement("p", null, isEn ? item == null ? void 0 : item.nameEN : item == null ? void 0 : item.nameTH))));
  }))) : !_.isEmpty(sessionSevId) ? React.createElement(React.Fragment, null, React.createElement("button", {
    className: 'btn-login login'
  }, !_.isEmpty(sessionSevId == null ? void 0 : sessionSevId.picture) ? React.createElement("img", {
    className: 'image-user',
    src: "" + (sessionSevId == null ? void 0 : sessionSevId.picture),
    width: 30,
    height: 30,
    title: 'profile',
    alt: 'profile'
  }) : React.createElement(RiUserFill, {
    size: 20
  })), React.createElement("ul", {
    className: 'menu-list'
  }, MENU_LIST$1.map(function (item, index) {
    return React.createElement(Fragment, {
      key: index
    }, item.id === 'signout' ? React.createElement("li", {
      className: 'list-item',
      // href={item?.link}
      // title={item.nameTH}
      onClick: function onClick() {
        sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_POSITION,
          router: router == null ? void 0 : router.pathname,
          position: 'on:header',
          section: 'login',
          data: {
            title: _key,
            heading: item == null ? void 0 : item.nameTH,
            index: index + 1
          }
        });
        handleLogout();
      }
    }, item == null ? void 0 : item.icon, React.createElement("p", null, isEn ? item == null ? void 0 : item.nameEN : item == null ? void 0 : item.nameTH)) : React.createElement("li", {
      className: 'list-item'
    }, React.createElement("a", {
      href: item == null ? void 0 : item.link,
      title: item.nameTH,
      onClick: function onClick() {
        sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_POSITION,
          router: router == null ? void 0 : router.pathname,
          position: 'on:header',
          section: 'login',
          data: {
            title: _key,
            heading: item == null ? void 0 : item.nameTH,
            index: index + 1
          }
        });
      }
    }, item == null ? void 0 : item.icon, React.createElement("p", null, isEn ? item == null ? void 0 : item.nameEN : item == null ? void 0 : item.nameTH))));
  }))) : React.createElement(React.Fragment, null, React.createElement("button", {
    className: 'btn-login',
    onClick: function onClick() {
      sendDataLayerGlobal({
        type: DATALAYER_TYPE.TRACK_POSITION,
        router: router == null ? void 0 : router.pathname,
        position: 'on:header',
        section: 'login',
        data: {
          title: _key,
          heading: 'open-login'
        }
      });
      setOpen(true);
    }
  }, React.createElement(RiUserFill, {
    size: 20
  })), open && React.createElement(WidgetSocial$1, {
    id: 'widget-social'
  }, React.createElement("div", {
    className: 'modal-social'
  }, React.createElement("button", {
    className: 'btn-close',
    onClick: function onClick() {
      if (open) {
        setError('');
        setOpen(false);
        sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_POSITION,
          router: router == null ? void 0 : router.pathname,
          position: 'on:header',
          section: 'login',
          data: {
            title: _key,
            heading: 'close-login'
          }
        });
      }
    }
  }, React.createElement(RiCloseFill, {
    size: 25
  })), React.createElement("div", {
    className: 'heading'
  }, " ", isEn ? TEXT_LIST$1[0].nameEN : TEXT_LIST$1[0].nameTH, " "), isLoading ? React.createElement(CircularLoadWrapper, {
    className: 'circle-loader'
  }, React.createElement("div", {
    className: "circle border"
  })) : PROVIDERS_MEMBER_AUTHO(nextAuthUrl).map(function (item, index) {
    return React.createElement(React.Fragment, null, React.createElement("button", {
      key: index,
      className: "btn-social " + (item.id ? "icon-" + item.id + " " + (conditionDisabled ? 'disabled' : '') : ''),
      // disabled={conditionDisabled}
      onClick: function onClick() {
        if (conditionDisabled) {
          setError('* กรุณายอมรับนโยบาย');
        } else {
          setIsLoading(true);
          var expiryDate = new Date();
          expiryDate.setMonth(expiryDate.getMonth() + 1);
          Cookies.set('login', 'success', {
            expires: expiryDate
          }); // 1 Month
          handleLogin(item == null ? void 0 : item.provider);
          localStorage.setItem('login_channel', item == null ? void 0 : item.provider);
          sendDataLayerGlobal({
            type: DATALAYER_TYPE.TRACK_INDEX,
            router: router == null ? void 0 : router.pathname,
            section: 'login',
            data: {
              heading: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A " + (item == null ? void 0 : item.id),
              title: _key,
              index: index + 1
            }
          });
        }
      }
    }, item == null ? void 0 : item.icon, React.createElement("p", null, !isEn ? TEXT_LIST$1[1].nameTH : TEXT_LIST$1[1].nameEN, " ", React.createElement("span", null, " ", item == null ? void 0 : item.id))));
  }), !_.isEmpty(error) && React.createElement("label", {
    className: 'error-label'
  }, " ", !conditionDisabled ? '' : error), !cookie && React.createElement(React.Fragment, null, children, React.createElement("a", {
    className: 'link-policy',
    href: '/privacy-policy',
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: function onClick() {
      return sendDataLayerGlobal({
        type: DATALAYER_TYPE.TRACK,
        router: router == null ? void 0 : router.pathname,
        section: 'login',
        data: {
          title: _key,
          heading: 'รายละเอียดเพิ่มเติม'
        }
      });
    }
  }, !isEn ? TEXT_LIST$1[2].nameTH : TEXT_LIST$1[2].nameEN))))));
};
var WidgetWrapper$1 = /*#__PURE__*/styled.div(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n  display: block;\n  padding: 8px 0 8px 16px;\n  @media (max-width: 768px) {\n    padding: 8px 10px 8px 16px;\n  }\n  &:hover {\n    .menu-list {\n      display: flex;\n    }\n    .btn-login {\n      svg {\n        color: #ffffffba;\n      }\n    }\n  }\n  /* ------------------------------ BUTTON LOGIN ------------------------------ */\n  .btn-login {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: transparent;\n\n    padding: 0;\n    border: none;\n    border-radius: 50px;\n    &.login {\n      border: 2px solid var(--text-color);\n      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.08)) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));\n    }\n\n    svg {\n      color: var(--text-color);\n      @media (max-width: 690px) {\n        height: 24px;\n        width: 24px;\n      }\n    }\n    .image-user {\n      overflow: hidden;\n      margin: 0px;\n      padding: 0px;\n      border-radius: 50px;\n      object-fit: cover;\n      width: 28px;\n      height: 28px;\n    }\n  }\n\n  .info {\n    font-size: 12px;\n    font-weight: 300;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-direction: column;\n    .username,\n    .email {\n      width: 150px;\n      font-size: 14px;\n      font-weight: 400;\n      text-transform: capitalize;\n\n      padding: 5px;\n      margin: 0;\n    }\n  }\n\n  .menu-list {\n    z-index: 100 !important;\n    display: none;\n    position: absolute;\n    top: 45px;\n    right: 0;\n    background-color: #ffffff;\n    box-shadow: 1px 0px 10px 0px var(--shadow-color);\n    width: max-content;\n    flex-direction: column;\n    border-radius: 5px;\n    margin: 0;\n    padding: 10px !important;\n    &:before {\n      content: '';\n      position: absolute;\n      top: -8px;\n      right: 0px;\n      width: 0;\n      height: 0;\n      border-left: 15px solid transparent;\n      border-right: 15px solid transparent;\n      border-bottom: 15px solid white;\n    }\n    @media (max-width: 767px) {\n      left: auto;\n      right: 10px;\n      top: 47px;\n      &:before {\n        top: -5px;\n        right: 10px;\n        left: auto;\n      }\n    }\n    .list-item {\n      width: 100%;\n      margin: 0;\n      a {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        svg {\n          margin-right: 5px;\n        }\n      }\n    }\n\n    svg {\n      color: var(--primary-color);\n      font-weight: 700;\n      margin-left: 5px;\n      margin-bottom: 2px;\n      transition: all 3ms ease-in;\n    }\n    li {\n      cursor: pointer;\n      width: 100%;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      font-size: 14px;\n      font-weight: 500;\n      margin: 0;\n      padding: 8px;\n      font-family: 'Prompt', sans-serif;\n      gap: 5px;\n      z-index: 2;\n      border-radius: 5px;\n      p {\n        padding: 0;\n        margin: 0;\n        color: var(--primary-color);\n      }\n      &:hover {\n        box-shadow: 1px 0px 10px 0px rgba(237, 26, 59, 0.3);\n        background-color: var(--primary-color);\n        p,\n        svg {\n          color: #fff;\n        }\n      }\n    }\n  }\n"])));
var WidgetSocial$1 = /*#__PURE__*/styled.div(_templateObject2$1 || (_templateObject2$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  background-color: rgb(0, 0, 0, 0.5);\n  z-index: 15;\n  .bottom-line {\n    width: 100%;\n    height: 2px;\n    background-color: rgba(0, 0, 0, 0.15);\n  }\n  .modal-social {\n    background: linear-gradient(103.43deg, #f6f6f6 0%, #eeeeee 100%);\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.85);\n    border-radius: 10px;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 10px;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    gap: 16px;\n    padding: 40px 30px;\n    @media (max-width: 767px) {\n      padding: 20px;\n      width: 320px;\n    }\n    @media (max-width: 380px) {\n      width: 300px;\n    }\n\n    .heading {\n      color: var(--primary-color);\n      font-size: 26px;\n      font-weight: 900;\n      display: block;\n      text-align: center;\n      margin-bottom: 10px;\n      /* border-bottom: 1px solid var(--primary-color); */\n      /* padding-bottom: 15px; */\n      @media (max-width: 767px) {\n        font-size: 24px;\n      }\n      @media (max-width: 380px) {\n        margin-top: 10px;\n        margin-bottom: 5px;\n      }\n    }\n    /* ------------------------------ BUTTON CLOSE ----------------------------- */\n    .btn-close {\n      position: absolute;\n      top: 20px;\n      right: 10px;\n      cursor: pointer;\n      border: none;\n      background-color: transparent;\n      transition: all ease 0.25ms;\n\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      svg {\n        color: var(--primary-color);\n      }\n      @media (max-width: 767px) {\n        top: 10px;\n      }\n\n      &:hover {\n        color: #474747;\n      }\n    }\n    /* ------------------------------ BUTTON SOCIAL ----------------------------- */\n    .btn-social {\n      cursor: pointer;\n      transition: background-color ease-in-out 100ms;\n      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.08)) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));\n      background-color: #ffffff;\n      border-radius: 50px;\n      color: #fff;\n      border: 0;\n\n      gap: 16px;\n      padding: 16px 30px;\n\n      width: 100%;\n      max-width: 345px;\n      margin: auto;\n      height: 48px;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      @media (max-width: 767px) {\n        padding: 16px;\n      }\n      p {\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 1.25;\n        color: #111;\n\n        span {\n          text-transform: capitalize;\n        }\n        @media (max-width: 767px) {\n          font-size: 16px;\n        }\n      }\n\n      &.icon-google {\n        color: #000000;\n        background: #ffffff;\n        &:hover {\n          background: #e5e5e5;\n          color: #ffffff;\n        }\n      }\n      &.icon-facebook {\n        background: #ffffff;\n        svg {\n          color: #337fff;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n      &.icon-line {\n        background: #ffffff;\n        svg {\n          color: #3ace01;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n      &.icon-tiktok {\n        background: #ffffff;\n        svg {\n          color: #000;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n      &.icon-linkin {\n        background: #ffffff;\n        svg {\n          color: #337fff;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n    }\n  }\n"])));
var CircularLoadWrapper = /*#__PURE__*/styled.div(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100px;\n  height: 100px;\n  align-self: center;\n  margin: 10px 50px;\n  .circle {\n    height: 100%;\n    right: 0px;\n    position: absolute;\n    border: solid 15px  #a9a9a9;\n    border-top-color:  #000;\n    border-radius: 50%;\n  }\n\n  .border {\n    width: 100%;\n    transform: rotate(135deg);  \n    animation: spin 1.3s steps(2) .2s infinite;\n    -webkit-animation: spin 1.3s linear infinite;\n\n  }\n\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])));

export { PROVIDERS_MEMBER, PROVIDERS_MEMBER_AUTHO, WidgetLogin, WidgetLoginAuthO };
//# sourceMappingURL=nation-login-widgets.esm.js.map
